import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { TMaterialStyles } from '../../../theme';
import React, { useCallback } from 'react';
import { ModalWrapper } from '../../Wrappers/ModalWrapper';
import { ButtonOutlined } from '../../Buttons/ButtonOutlined';
import { useTranslation } from 'react-i18next';
import TypographyWithShadow from '../../Typography/TypographyWithShadow';

interface IFailedGameModal {
  setIsStreetView: (data: boolean) => void;
  disableTries: boolean;
  attempts?: number;
  showFailedGameModal: boolean;
  setShowFailedGameModal: (value: boolean) => void;
  fetchDataFunction: () => Promise<void>;
  setIsTimerDisabled: (value: boolean) => void;
  setIsLocationSubmitted?: (value: boolean) => void;
  refreshGoogleMap?: () => void;
}

export const FailedGameModal: React.FC<IFailedGameModal> = ({
  setIsStreetView,
  disableTries,
  attempts,
  showFailedGameModal,
  setShowFailedGameModal,
  fetchDataFunction,
  setIsTimerDisabled,
  setIsLocationSubmitted,
  refreshGoogleMap,
}) => {
  const { t } = useTranslation();

  const handleTryAgain = useCallback(async () => {
    try {
      await fetchDataFunction();
      setIsStreetView(true);
      setShowFailedGameModal(false);
      setIsTimerDisabled(false);
      setIsLocationSubmitted && setIsLocationSubmitted(false);
      refreshGoogleMap && refreshGoogleMap();
    } catch (error) {
      console.error('Error while [handleTryAgain]', error);
    }
  }, [
    fetchDataFunction,
    setIsStreetView,
    setIsTimerDisabled,
    setShowFailedGameModal,
    setIsLocationSubmitted,
    refreshGoogleMap,
  ]);

  return (
    <Modal
      open={showFailedGameModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalWrapper hasLabel attempts={attempts}>
        <Box sx={materialStyles.container}>
          <TypographyWithShadow sx={materialStyles.title} shadowType="DARK">
            {t('game.time_is_up')}
          </TypographyWithShadow>

          <Box sx={materialStyles.buttonWrapper}>
            <ButtonOutlined
              shadowType="DARK"
              sx={materialStyles.tryAgain}
              onClick={handleTryAgain}
              disabled={disableTries}
            >
              {t('game.play_again')}
            </ButtonOutlined>
          </Box>
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    padding: '30px 30px',
  },
  buttonWrapper: {
    marginTop: 2,
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '25px',
    textAlign: 'center',
  },
};
